<template>
    <div>
        <small>Note: clearing the publication cache can increase load times for users</small>
        <br/>
        <b-btn variant="warning" @click="clearPubCache" :disabled="isBusy">Clear Publication Cache</b-btn>
    </div>
</template>
<script>
import Vue from 'vue'

export default {
    name: "StoreConfig",
    data: {
        isBusy: false,
    },
    methods: {
        async clearPubCache() {
            this.isBusy = true;
            let response = await this.axios.post("/dashboard/cache/clear");
            this.$bvToast.toast("Publication cache cleared", {
                variant: 'success',
                solid: true,
                noCloseButton: true,
                autoHideDelay: 2000
            });
            this.isBusy = false;
        }
    }
}
</script>



<style scoped lang="scss">

</style>